import { render } from "./ReportCustomer.vue?vue&type=template&id=5349a6bb"
import script from "./ReportCustomer.vue?vue&type=script&lang=js"
export * from "./ReportCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__